// If source is the same as less than x minutes ago then don't add to array
const minutesPastPreviousSamePmVisit = 60
const trackWhenAnyPropertyHasContent = ['utm_campaign', 'utm_medium', 'utm_source', 'utm_term']

// A raw % in the URL (a Facebook in-app browser's fbclid, or a landing page stored from one) makes
// decodeURIComponent throw; the raw text compares and tracks as well
const decodeURIComponentSafe = (value: string): string => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const utmListLocalStorageKey = 'trackingUtmList'
export const gaIdCookieKey = '_ga'

export default defineNuxtPlugin(() => {
  callAfterDocumentIdle(() => {
    const route = useRoute()

    const parsePmVisitSource = () => {
      const utmSource = route.query?.utm_source
        ? decodeURIComponentSafe(returnFirstIfArray(route.query.utm_source)).replace(/\+/g, ' ')
        : ''
      const utmCampaign = route.query?.utm_campaign
        ? decodeURIComponentSafe(returnFirstIfArray(route.query.utm_campaign)).replace(/\+/g, ' ')
        : ''
      const utmMedium = route.query?.utm_medium
        ? decodeURIComponentSafe(returnFirstIfArray(route.query.utm_medium)).replace(/\+/g, ' ')
        : ''
      const utmTerm = route.query?.utm_term
        ? decodeURIComponentSafe(returnFirstIfArray(route.query.utm_term)).replace(/\+/g, ' ')
        : ''

      let httpReferrer = document.referrer
      const httpReferrerLength = httpReferrer.length
      httpReferrer = httpReferrer.substr(0, 2000)
      let landingPage = null
      let landingPageLength = 0
      try {
        landingPage = window.location.href.toString().split(window.location.host)[1]
        landingPageLength = landingPage.length
        landingPage = landingPage.substr(0, 2000)
      } catch {
      // Ignore the error and continue execution.
      }

      return {
        utm_source: utmSource.substr(0, 100),
        utm_campaign: utmCampaign.substr(0, 100),
        utm_medium: utmMedium.substr(0, 100),
        utm_term: utmTerm.substr(0, 100),
        http_referrer: httpReferrer,
        http_referrer_length: httpReferrerLength,
        landingpage: landingPage,
        landingpage_length: landingPageLength,
        time: (+new Date()) / 1E3 | 0,
      }
    }

    const newPmVisitSource = parsePmVisitSource()

    if (trackWhenAnyPropertyHasContent.every(property => newPmVisitSource[property as keyof typeof newPmVisitSource] === '')) {
      return
    }

    const pmVisitSourcesStorage = tryGetLocalStorage(utmListLocalStorageKey)

    if (pmVisitSourcesStorage) {
      let prevPmVisitSources = []
      try {
        prevPmVisitSources = JSON.parse(pmVisitSourcesStorage)
      } catch {
      // Ignore the error and continue execution.
      }

      if (prevPmVisitSources?.length) {
        const lastPmVisitSource = prevPmVisitSources[prevPmVisitSources.length - 1]
        const sameTimeMsThrottle = 60 * minutesPastPreviousSamePmVisit

        if (
          decodeURIComponentSafe(lastPmVisitSource.landingpage ?? '') !== decodeURIComponentSafe(newPmVisitSource.landingpage ?? '') ||
        lastPmVisitSource.time + sameTimeMsThrottle < newPmVisitSource.time
        ) {
          prevPmVisitSources.push(newPmVisitSource)
          trySetLocalStorage(utmListLocalStorageKey, JSON.stringify(prevPmVisitSources))
        }
      } else {
        trySetLocalStorage(utmListLocalStorageKey, JSON.stringify([newPmVisitSource]))
      }
    } else {
      trySetLocalStorage(utmListLocalStorageKey, JSON.stringify([newPmVisitSource]))
    }
  })
})
